import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../../../base/BaseComponent';
import {Checkbox, Tooltip} from "antd";
import moment from "moment";
import {formatSecondsFont, unitConvert} from "../../../../../utils";
import Titlepicfile from "../../../../components/titlepicfile/Titlepicfile";
import lock from "../../resourcePool/img/lock.png";
import play  from '../../resourcePool/img/play.png'
export default class Video extends BaseComponent {
    static defaultProps = {
        checked: false,
        title: 'vvvvddd',
        size: '250.4M',
        timeRanges: '5分20秒',
        img: "images/folder.png",
        onClick: () => {
            console.log("点击");
        },
        IsChecked:()=>{

        }
    };
    static propTypes = {
        title: PropTypes.string.isRequired,//传入dom 结构
        size: PropTypes.string.isRequired,//文件大小
        timeRanges:PropTypes.string.isRequired,//时间范围
        onClick: PropTypes.func.isRequired,//点击函数
        img:PropTypes.string.isRequired,//传入图标
        IsChecked: PropTypes.func.isRequired,//选中的函数

    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    handleEnter() {
        this.setState({hover: true})
    }

    handleOut() {
        this.setState({hover: false})
    }
    render() {
        // 鼠标划过
        let isHover;
        if(this.props.checked){
            isHover ='block'
        }else{
            isHover ='none';
            if(this.state.hover){
                isHover ='block'
            }else{
                isHover ='none'
            }
        }
        return (
            <div>
                {this.renderFileCard(isHover)}
            </div>)
    }
    renderFileCard(isHover)  {
        let size = this.props.file['size']
        return (
            <div style={{width: '176px', }}
                 onMouseEnter={() => this.handleEnter()}
                 onMouseLeave={() => this.handleOut()}
                 >
                <div style={{width: '176px', height: '99px', marginBottom: '8px', position: "relative"}}>
                    <div onClick={() => {this.props.onClick()}}>
                        <Titlepicfile src={this.props.file['thumbnailsPath']} style={{width: '176px', height: '99px',cursor: "pointer"}}/>
                    </div>
                     <img src={play} onClick={()=>{
                         this.props.onClick&&this.props.onClick()
                     }}  style={{
                        position:'absolute',
                        top:'50%',
                        left:'50%',
                        marginLeft:'-15px',
                        marginTop:'-16px',
                        zIndex:1,
                        fontSize:'16px',
                        cursor: "pointer",
                        color:'#ffffff'}} />
                    {this.props.IsDownLoad?<div style={{width: '176px', height: '99px', marginBottom: '8px',zIndex:'9' , position: "absolute",top:0,left:0,background: 'rgba(0,0,0,0.2600)'}} onClick={()=>{
                        this.props.applyDownload&&this.props.applyDownload()
                    }}></div>:null}
                    {this.props.IsDownLoad? <img src={lock}  style={{
                        position:'absolute',
                        top:5,
                        left:7,
                        zIndex:10,
                        fontSize:'16px',
                        color:'#ffffff'}}  onClick={()=>{
                        this.props.applyDownload&&this.props.applyDownload()
                    }}/>:null}
                    <div style={{
                        minWidth: '59px',
                        height: '20px',
                        lineHeight: '20px',
                        textAlign: 'center',
                        position: 'absolute',
                        bottom: '0',
                        zIndex:'20',
                        right: '0',
                        background: 'rgba(0, 0, 0, 0.4)',
                        fontSize: '10px',
                        color: 'rgba(255, 255, 255, 1)'
                    }}>{this.props.file['duration']?formatSecondsFont(this.props.file['duration']/1000):"00分00秒"}
                    </div>
                    {/*<Checkbox  checked={this.props.checked} style={{display:isHover,position:'absolute',right:9,top:9}}  onChange={(e)=>{*/}
                    {/*    this.props.IsChecked&&this.props.IsChecked(e)}}>*/}
                    {/*</Checkbox>*/}
                    <div  style={{width:35,height:35,display: isHover, position: 'absolute', right: 0, top: 0,zIndex:10,cursor: "pointer"}}
                         onClick={() => {
                             this.props.IsChecked && this.props.IsChecked(!this.props.checked)
                         }}>
                        <Checkbox checked={this.props.checked} style={{marginLeft:10,marginTop:5}}>
                        </Checkbox>
                    </div>
                </div>
                <div style={{height: "36px", textAlign: 'center', lineHeight: '18px'}}>
                        <div  className={'twoText'} style={{fontSize: '14px',overflow: 'hidden',textOverflow:'ellipsis', color: "rgba(0, 0, 0, 0.65)"}}  title={this.props.file['name'] || ""}>{this.props.file['name'] || ""}</div>
                    <div style={{fontSize: '12px', color: "rgba(0, 0, 0, 0.45"}}>{size?unitConvert(size):'0B'}</div>
                </div>
            </div>
        )
    }

}
